import { CheckoutStatus } from '@app/react-common/models/CheckoutStatus';

export interface TrafficAllocationVariant {
  internalId?: number;
  name: string;
  checkoutStatus?: CheckoutStatus;
  description?: string;
  percentageTraffic: number;
  isSelected: boolean;
  widgetExternalId: number | null;
  widgetApiId?: number;
  apiId: number | null;
  variantType?: string;
  groupTypeLabel?: string;
  slotIndex?: number;
  previewUrl?: string;
  updatedAt?: string;
  checkoutGroupIds?: number[];
  widgetSelections?: TrafficAllocationWidgetSelection[];
}

export interface TrafficAllocationWidgetSelection {
  widgetExternalId: number | null;
  widgetApiId?: number;
}

export interface TrafficAllocationConfig {
  variants: TrafficAllocationVariant[];
}

export interface TrafficAllocationFormData {
  variants: TrafficAllocationVariant[];
}

// each group type is served by a different shopify block, so a mixed test never renders its other variant
export function matchesControlGroupType(
  variant: TrafficAllocationVariant,
  controlGroupTypeLabel: string | null,
): boolean {
  return !controlGroupTypeLabel || !variant.groupTypeLabel || variant.groupTypeLabel === controlGroupTypeLabel;
}

export function findControlGroupTypeLabel(variants: TrafficAllocationVariant[]): string | null {
  return variants.find((variant) => variant.isSelected && variant.slotIndex === 0)?.groupTypeLabel ?? null;
}
